import * as Library from '../library/index';
import { Simple } from './simple';
/**
 * Class: Base
 */
export class Base extends Simple {
  public label: string;
  public type: any;
  /**
   * hasLabel()
   * @returns {*}
   */
  hasLabel() {
    return Library.isStringWithLength(this.label);
  }
  /**
   * hasType()
   * @returns {*}
   */
  hasType() {
    return Library.isDefined(this.type);
  }
  /**
   * Constructor()
   */
  constructor();
  constructor(options: object)
  constructor(options?: any) {
    super(options);
    this.label = Library.init(options, 'label');
    this.type = Library.init(options, 'type');
  }
}
